import { Injectable } from '@angular/core';
import { ScreenHelpDto } from '@flyfreely-portal-ui/flyfreely';
import { ReplaySubject, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { EnhancedHelpTreeService } from './enhanced-help-tree.service';
import { EnhancedHelpService } from './enhanced-help.service';

export const defaultKnowledgeBaseUrl = 'https://knowledge.flyfreely.io/';

@Injectable({
    providedIn: 'root'
})
export class KnowledgeBaseService {
    allLinksSubject = new ReplaySubject<ScreenHelpDto[]>();
    allLinks$ = this.allLinksSubject.asObservable();
    screenLookup: { [analyticsScreenName: string]: string };

    private ngUnsubscribe$ = new Subject<void>();
    constructor(
        private enhancedHelpService: EnhancedHelpService,
        private enhancedHelpTreeService: EnhancedHelpTreeService
    ) {
        this.enhancedHelpService
            .findAllScreenHelp()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(links => {
                this.allLinksSubject.next(links);
            });
        this.screenLookup = this.enhancedHelpTreeService.screenTree.reduce(
            (acc, t) => ({
                ...acc,
                [t.analyticsIdentifier]: t.identifier
            }),
            {}
        );
    }

    ngOnDestroy() {
        this.allLinksSubject.complete();
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    findKnowledgeBaseUrlByScreen(screen: string) {
        return this.allLinks$.pipe(
            map(links =>
                links.find(
                    link =>
                        link != null &&
                        link.screen === this.screenLookup[screen]
                )
            )
        );
    }
}
